import React from 'react';
import PropTypes from 'prop-types';

const NewNavbarContext = React.createContext(undefined);

// Actions
export const TOGGLE_OPEN = 'TOGGLE_OPEN';
export const CLOSE = 'CLOSE';

const init = () => {
  return {
    isOpen: false,
  };
};

// Reducer
const reducer = (state, action) => {
  switch (action.type) {
    case TOGGLE_OPEN: {
      return {
        ...state,
        isOpen: !state.isOpen,
      };
    }
    case CLOSE: {
      return {
        ...state,
        isOpen: false,
      };
    }
    default: {
      throw new Error(`Unhandled NewNavbarContext action type: ${action.type}`);
    }
  }
};

const NewNavbarProvider = ({
  children,
}) => {
  const [state, dispatch] = React.useReducer(reducer, null, init);

  const handleToggleOpen = React.useCallback(() => {
    dispatch({ type: TOGGLE_OPEN });
  }, [state]);

  const handleClose = React.useCallback(() => {
    dispatch({ type: CLOSE });
  }, [state]);

  const memoizedValue = React.useMemo(() => {
    return {
      isOpen: state.isOpen,
      toggleOpen: handleToggleOpen,
      close: handleClose,
    };
  }, [state, handleToggleOpen]);

  return (
    <NewNavbarContext.Provider value={memoizedValue}>
      {children}
    </NewNavbarContext.Provider>
  );
};

const useNewNavbarContext = () => {
  const context = React.useContext(NewNavbarContext);
  if (context === undefined) {
    throw new Error('useNewNavbarContext must be used within a NewNavbarProvider');
  }
  return context;
};

NewNavbarProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};

export {
  NewNavbarProvider,
  useNewNavbarContext,
};
